module.exports = __webpack_public_path__ + "img/DZA.0fcdb133.svg";